import { Action, createReducer, on } from '@ngrx/store';
import { WebSocketState } from '../models/message';
import { WebSocketActions } from './websocket.actions';


export const initialState: WebSocketState = {
  isConnected: false,
  lastMessage: null,
  connectionId: null,
  workspaceId: null,
  userId: null,
};

/**
 * Updating
 */
const _webSocketReducer = createReducer(
  initialState,
  on(WebSocketActions.connectWebSocket, (state) => ({ ...state })),
  on(WebSocketActions.disconnectWebSocket, (state) => ({ ...state })),
  on(WebSocketActions.webSocketConnected, (state) => ({
    ...state,
    isConnected: true,
  })),
  on(WebSocketActions.webSocketDisconnected, (state) => ({
    ...state,
    isConnected: false,
  })),
  on(WebSocketActions.sendMessage, (state) => ({ ...state })), // Assuming no state change on send
  on(WebSocketActions.messageReceived, (state, { message }) => ({
    ...state,
    lastMessage: message,
  })),
  on(WebSocketActions.setConnectionId, (state, { connectionId }) => ({
    ...state,
    connectionId,
  })),
  on(WebSocketActions.setWorkspaceId, (state, { workspaceId }) => ({
    ...state,
    workspaceId,
  })),
  on(WebSocketActions.setUserId, (state, { userId }) => ({
    ...state,
    userId,
  })),
);

export function webSocketReducer(
  state: WebSocketState | undefined,
  action: Action,
) {
  return _webSocketReducer(state, action);
}
